import React, { useEffect, useState, useCallback } from 'react';

import './ProgressBar.css';

const heightWindow = window.innerHeight;

const ProgressBar = (props) => {
    const [visible, setVisible] = useState(false);

    const handleVisible = useCallback(() => {
        if (visible === false) {
            const posTopElement = document.getElementById(props.id).getBoundingClientRect().y;
            const posBottomElement = posTopElement + (document.getElementById(props.id).getBoundingClientRect().height / 5);
            if ((heightWindow) > (posBottomElement)) {
                setVisible(true);
                window.removeEventListener('scroll', handleVisible, true);
            }
        }
    }, [props.id, visible]);

    useEffect(() => {
        setVisible(heightWindow > (document.getElementById(props.id).getBoundingClientRect().y + (document.getElementById(props.id).getBoundingClientRect().height / 5)));
    }, [props.id]);

    useEffect(() => {
        window.addEventListener('scroll', handleVisible, true);
        return (() => {
            window.removeEventListener('scroll', handleVisible, true);
        });
    }, [handleVisible]);

    return (
        <div id={props.id} name={props.id} className="px-xl-5 px-lg-4 px-md-3 py-3">
            <div className="d-block">
                <span className="custom-float-start custom-text-black custom-name-progress">{props.name}</span>
                <span className="custom-float-end custom-text-black custom-name-progress">{props.value}%</span>
            </div>
            <br/>
            <div className="progress custom-progress">
                <div className={visible ? "custom-progress-animate progress-bar custom-progress-bar": "progress-bar custom-progress-bar"} role="progressbar" style={{width: `${props.value}%`}} aria-valuenow={props.value} aria-valuemin="0" aria-valuemax="100"></div>
            </div>
        </div>
    );
};

export default ProgressBar;